import Checkbox from "components/CheckBox";
import Heading from "components/Heading";
import DashboardLayout from "layouts/DashboardLayout";
import React from "react";
import PageContent from "./PageContent";
import { items } from "./items";

function AddPlan() {
  const [selected, setSelected] = React.useState<string[]>([]);
  // const navigate = useNavigate();
  return (
    <DashboardLayout title="Add Plan">
      <div className="px-8 pt-4 shadow-md pb-8 bg-white rounded-lg mb-8">
        <Heading
          heading="Add Fee Plan"
          subHeading="Select Fee Plan"
          border
          className="mb-8"
        />
        <Checkbox
          selected={selected}
          setSelected={setSelected}
          items={items}
          className="w-full gap-8"
        />
        <section className="my-12">
          <PageContent selected={selected} />
        </section>
      </div>
    </DashboardLayout>
  );
}

export default AddPlan;
